import React, { useState } from 'react';
import { ConversationList } from '../components/chat/ConversationList';
import { ChatHeader } from '../components/chat/ChatHeader';
import { MessageList } from '../components/chat/MessageList';
import { MessageInput } from '../components/chat/MessageInput';
import { Button } from '../components/ui/Button';
import { MessageCircle, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Mock Data
const conversations = [{
  id: '1',
  name: 'Sarah Klein',
  handle: 'sarah.style',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=800&auto=format&fit=crop&q=60',
  lastMessage: 'Thanks for the update! Looking forward to working on this 🚀',
  timestamp: '2h ago',
  unreadCount: 2,
  isOnline: true
}, {
  id: '2',
  name: 'Tom Weber',
  handle: 'tom_travels',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800&auto=format&fit=crop&q=60',
  lastMessage: 'Can we schedule a call tomorrow?',
  timestamp: '5h ago',
  unreadCount: 0,
  isOnline: false
}, {
  id: '3',
  name: 'Lisa Schmidt',
  handle: 'lisa.fitness',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&auto=format&fit=crop&q=60',
  lastMessage: 'Just posted the content, check it out!',
  timestamp: '1d ago',
  unreadCount: 0,
  isOnline: true
}, {
  id: '4',
  name: 'Felix Meyer',
  handle: 'felix_tech',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800&auto=format&fit=crop&q=60',
  lastMessage: "Sure, I'll send the media kit by EOD",
  timestamp: '2d ago',
  unreadCount: 1,
  isOnline: false
}, {
  id: '5',
  name: 'Emma Wilson',
  handle: 'emma.eats',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&auto=format&fit=crop&q=60',
  lastMessage: "Perfect! Let's finalize the contract",
  timestamp: '3d ago',
  unreadCount: 0,
  isOnline: true
}, {
  id: '6',
  name: 'David Brown',
  handle: 'david.photo',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&auto=format&fit=crop&q=60',
  lastMessage: 'I have some questions about the campaign',
  timestamp: '4d ago',
  unreadCount: 0,
  isOnline: false
}, {
  id: '7',
  name: 'Sophie Miller',
  handle: 'sophie_art',
  avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656ec?w=800&auto=format&fit=crop&q=60',
  lastMessage: "Sounds good, I'm in!",
  timestamp: '1w ago',
  unreadCount: 0,
  isOnline: false
}, {
  id: '8',
  name: 'James Wilson',
  handle: 'james.gym',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=800&auto=format&fit=crop&q=60',
  lastMessage: 'When is the deadline?',
  timestamp: '1w ago',
  unreadCount: 0,
  isOnline: true
}];
const initialMessages = [{
  id: '1',
  content: 'Hi! I wanted to discuss the upcoming campaign',
  timestamp: '9:30 AM',
  isSent: false,
  status: 'read' as const
}, {
  id: '2',
  content: 'Hi Sarah! Of course, what would you like to know?',
  timestamp: '9:32 AM',
  isSent: true,
  status: 'read' as const
}, {
  id: '3',
  content: "What's the timeline and deliverables?",
  timestamp: '9:35 AM',
  isSent: false,
  status: 'read' as const
}, {
  id: '4',
  content: 'The campaign runs for 2 weeks starting next Monday. We need 3 posts and 5 stories.',
  timestamp: '9:40 AM',
  isSent: true,
  status: 'read' as const
}, {
  id: '5',
  content: 'Thanks for the update! Looking forward to working on this 🚀',
  timestamp: '11:15 AM',
  isSent: false,
  status: 'read' as const
}];
export function ChatPage() {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<string | null>('1');
  const [messages, setMessages] = useState(initialMessages);
  const [isTyping, setIsTyping] = useState(true);
  const selectedConversation = conversations.find(c => c.id === selectedId);
  const handleSendMessage = (content: string) => {
    const newMessage = {
      id: Date.now().toString(),
      content,
      timestamp: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      }),
      isSent: true,
      status: 'sent' as const
    };
    setMessages([...messages, newMessage]);
    // Simulate reply
    setIsTyping(true);
    setTimeout(() => {
      setIsTyping(false);
      const reply = {
        id: (Date.now() + 1).toString(),
        content: 'Got it! Thanks for the info.',
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        }),
        isSent: false,
        status: 'read' as const
      };
      setMessages(prev => [...prev, reply]);
    }, 3000);
  };
  return <div className="flex h-screen bg-gray-100 overflow-hidden" data-id="element-467">
      {/* Sidebar - Hidden on mobile when chat is selected */}
      <div className={`w-full md:w-[360px] lg:w-[400px] flex-shrink-0 bg-white border-r flex flex-col ${selectedId ? 'hidden md:flex' : 'flex'}`} data-id="element-468">
        <div className="p-4 border-b flex items-center justify-between md:hidden" data-id="element-469">
          <Button variant="ghost" size="sm" onClick={() => navigate('/manager')} data-id="element-470">
            <ArrowLeft className="h-4 w-4 mr-2" data-id="element-471" /> Back to Dashboard
          </Button>
        </div>
        <div className="hidden md:flex p-4 border-b items-center" data-id="element-472">
          <Button variant="ghost" size="sm" onClick={() => navigate('/manager')} className="mr-2" data-id="element-473">
            <ArrowLeft className="h-4 w-4" data-id="element-474" />
          </Button>
          <h1 className="font-bold text-lg" data-id="element-475">Inbox</h1>
        </div>
        <ConversationList conversations={conversations} activeId={selectedId || undefined} onSelect={setSelectedId} data-id="element-476" />
      </div>

      {/* Main Chat Area */}
      <div className={`flex-1 flex flex-col h-full bg-gray-50 ${!selectedId ? 'hidden md:flex' : 'flex'}`} data-id="element-477">
        {selectedId && selectedConversation ? <>
            <ChatHeader name={selectedConversation.name} handle={selectedConversation.handle} avatar={selectedConversation.avatar} isOnline={selectedConversation.isOnline} onBack={() => setSelectedId(null)} data-id="element-478" />
            <MessageList messages={messages} otherUserAvatar={selectedConversation.avatar} isTyping={isTyping} data-id="element-479" />
            <MessageInput onSend={handleSendMessage} data-id="element-480" />
          </> : <div className="flex-1 flex flex-col items-center justify-center text-gray-400 p-8" data-id="element-481">
            <div className="h-24 w-24 bg-gray-100 rounded-full flex items-center justify-center mb-6" data-id="element-482">
              <MessageCircle className="h-12 w-12 text-gray-300" data-id="element-483" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-484">
              Your Messages
            </h3>
            <p className="text-center max-w-sm" data-id="element-485">
              Select a conversation from the sidebar to start chatting with your
              creators.
            </p>
          </div>}
      </div>
    </div>;
}